import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		formPopupSingleLineAddressVerification_formContainer: {

		},
		formPopupSingleLineAddressVerification_headerMessage: {
			color: theme.palette.info.main,
			fontWeight: theme.typography.fontWeightBold as any,
			fontSize: theme.typography.h6.fontSize,
			padding: theme.spacing(1.5, 1.5),
			lineHeight: theme.spacing(3.5)
		},
		formPopupSingleLineAddressVerification_wholeRow: {
			width: '100%',
			display: 'flex',
			flexWrap: 'wrap',
		},
		formPopupSingleLineAddressVerification_wholeRowColumn: {
			padding: theme.spacing(3, 1.5),
			flex: '1 0',
			minWidth: '300px',
		},
	});
});

export default useStyles;
